<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card>
        <v-form ref="add_form" @submit.prevent="createCredit">
          <div class="pa-3">
            <div>
              <v-radio-group v-model="addCredit.type_user">
                <div class="d-flex">
                  <div class="d-flex mr-1">
                    <div>
                      <v-radio color="#86bc3a" value="1" @click="clear_address"></v-radio>
                    </div>
                    <div>บุคคลธรรมดา</div>
                  </div>
                  <div class="d-flex ml-1">
                    <div>
                      <v-radio color="#86bc3a" value="2"></v-radio>
                    </div>
                    <div>นิติบุคคล</div>
                  </div>
                </div>
              </v-radio-group>
            </div>
            <div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-account</v-icon>
                    <div class="ml-1">รหัสลูกค้า : {{ addCredit.id }}</div>
                  </div>
                </div>
                <div class="mt-3 ml-1">
                  <div class="d-flex align-center">
                    <v-checkbox color="#86bc3a" class="ma-0" v-model="addCredit.clinics_ck" hide-details="auto"></v-checkbox>
                    <div>
                      ลูกค้าคลีนิค
                      <!--                    ลูกค้าคลีนิค <b style="color:red;">Coming Soon!</b>-->
                    </div>
                  </div>
                </div>

                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อ - สกุล" prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อ - สกุล']" :autofocus="focus_input" hide-details="auto" required  v-model="addCredit.name" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="เบอร์โทรสำหรับเข้าสู่ระบบ" type="tel" maxlength="11" @keypress="isNumber($event, addCredit.telephone)" prepend-inner-icon="mdi-phone-outline" hide-details="auto" :rules="phoneRules" v-model="addCredit.telephone" required outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="อีเมล" type="email" @keypress="isEmail($event)" prepend-inner-icon="mdi-email-outline" hide-details="auto" v-model="addCredit.email" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="เลขเสียภาษี" type="tel" maxlength="13" @keypress="isTaxNumber($event, addCredit.tax_number)" prepend-inner-icon="mdi-card-account-details-outline" hide-details="auto"  v-model="addCredit.tax_number" outlined></v-text-field>
                </div>

              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-credit-card</v-icon>
                    <div class="ml-1">เครดิต <span style="color:red;">*</span>(ยอดเครดิตไม่เกิน 1,000,000 บาท)</div>
                  </div>
                </div>
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-credit-card</v-icon>
                    <div class="ml-1">กำหนดจำนวนวันในการติดเครดิต <span style="color:red;">*</span>(วัน)</div>
                  </div>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" type="number" label="ยอดเครดิต" prepend-inner-icon="mdi-credit-card-outline" hide-details="auto"  @keypress="onlyNumberCredit($event, addCredit.credit_balance)" :rules="creditRules" placeholder="ยอดเครดิตไม่เกิน 1,000,000 บาท" v-model="addCredit.credit_balance" required outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" type="number" label="กำหนดจำนวนวันในการติดเครดิต" prepend-inner-icon="mdi-credit-card-outline" hide-details="auto"  @keypress="onlyNumberCredit($event, addCredit.credit_day)" :rules="credit_dayRules" placeholder="กำหนดจำนวนวันในการติดเครดิต" v-model="addCredit.credit_day" required outlined></v-text-field>
                </div>
              </div>
              <div class="grid_full">
                <div class="mt-3 mr-1">
                  <div class="d-flex">
                    <v-icon>mdi-home</v-icon>
                    <div class="ml-1">ที่อยู่ในการจัดส่ง</div>
                  </div>
                </div>
              </div>
              <div class="display_pc">
                <div class="grid_half">
                  <div class="mt-4 ml-1">บ้านเลขที่/ที่อยู่</div>
                  <div class="mt-4 ml-1">
                    <div class="d-flex align-center">
                      <v-checkbox color="#86bc3a" class="ma-0" v-model="addCredit.chiang_mai_cod" hide-details="auto"></v-checkbox>
                      <div>ส่งฟรีในเชียงใหม่</div>
                    </div>
                  </div>
                </div>
                <div class="grid_full">
                  <div class="mt-0">
                    <v-text-field class="mt-2 mr-1" color="#86bc3a" placeholder="บ้านเลขที่/ที่อยู่" hide-details="auto" required v-model="addCredit.address" outlined></v-text-field>
                  </div>
                </div>
              </div>
              <div class="display_mobile">
                <div class="grid_full">
                  <div class="mt-4 ml-1">
                    <div class="d-flex align-center">
                      <v-checkbox color="#86bc3a" class="ma-0" v-model="addCredit.chiang_mai_cod" hide-details="auto"></v-checkbox>
                      <div>ส่งฟรีในเชียงใหม่</div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                    <v-text-field class="mt-2 mr-1" color="#86bc3a" label="บ้านเลขที่/ที่อยู่" hide-details="auto" required v-model="addCredit.address" outlined></v-text-field>
                  </div>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <addressinput-subdistrict :store="mainDataStore" class="custom_css" placeholder="ตำบล/แขวง" v-model="addCredit.sub_district"/>
                </div>
                <div class="mt-3 mr-1">
                  <addressinput-district :store="mainDataStore" class="custom_css" placeholder="อำเภอ/เขต" v-model="addCredit.district"/>
                </div>
                <div class="mt-3 mr-1">
                  <addressinput-province :store="mainDataStore" class="custom_css" placeholder="จังหวัด" v-model="addCredit.province" />
                </div>
                <div class="mt-3 mr-1">
                  <addressinput-zipcode numbered :store="mainDataStore" class="custom_css" placeholder="รหัสไปรษณีย์" v-model="addCredit.postcode" />
                </div>
              </div>
              <div v-if="addCredit.type_user === '2'">
                <div class="grid_full">
                  <div class="mt-3">ที่อยู่ในการออกเอกสาร</div>
                  <v-radio-group v-model="addCredit.delivery_type">
                    <div class="d-flex">
                      <div class="d-flex mr-1">
                        <div>
                          <v-radio color="#86bc3a" value="0" @click="duplicate_address"></v-radio>
                        </div>
                        <div>เหมือนกัน</div>
                      </div>
                      <div class="d-flex ml-1">
                        <div>
                          <v-radio color="#86bc3a" value="1" @click="unduplicate_address"></v-radio>
                        </div>
                        <div>ไม่เหมือนกัน</div>
                      </div>
                    </div>
                  </v-radio-group>
                </div>
                <div v-if="addCredit.delivery_type === '1'">
                  <div class="grid_full">
                    <div class="mt-3">
                      <div class="ml-1">บ้านเลขที่/ที่อยู่</div>
                      <v-text-field class="mt-2 mr-1" color="#86bc3a" label="บ้านเลขที่/ที่อยู่" hide-details="auto" required v-model="addCredit.address_delivery" outlined></v-text-field>
                    </div>
                  </div>
                  <div class="grid_half">
                    <div class="mt-3 mr-1">
                      <addressinput-subdistrict :store="subDataStore" class="custom_css" placeholder="ตำบล/แขวง" v-model="addCredit.sub_district_delivery"/>
                    </div>
                    <div class="mt-3 mr-1">
                      <addressinput-district :store="subDataStore" class="custom_css" placeholder="อำเภอ/เขต" v-model="addCredit.district_delivery"/>
                    </div>
                    <div class="mt-3 mr-1">
                      <addressinput-province :store="subDataStore" class="custom_css" placeholder="จังหวัด" v-model="addCredit.province_delivery" />
                    </div>
                    <div class="mt-3 mr-1">
                      <addressinput-zipcode numbered :store="subDataStore" class="custom_css" placeholder="รหัสไปรษณีย์" v-model="addCredit.postcode_delivery" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <v-btn height="45" class="white--text grad-success-bg btn_mobile" type="submit" style="font-size: 18px">บันทึกข้อมูล</v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/axios.js'
import Swal from 'sweetalert2'
import { DataStore,  } from 'vue-thailand-address'
import {isTelephone, onlyForCurrency, onlyForNumberCredit, onPaste, taxNumber, validateEmail} from "@/js/handler"

const mainDataStore = new DataStore();
const subDataStore = new DataStore();

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      mainDataStore,
      subDataStore,
      checkbox: null,
      loading_page: false,
      focus_input: false,
      emailRules: [v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'อีเมลไม่ถูกต้อง !'],
      phoneRules: [v => ( v.length > 8 ) || "เบอร์โทรศัพท์ไม่ถูกต้อง !",],
      taxRules: [v => ( v.length === 13 ) || "เลขเสียภาษีไม่ถูกต้อง !",],
      creditRules: [v => !!v && (v <= 1000000) || 'ยอดเครดิตไม่ควรเกิน 1,000,000 บาท หรือ ห้ามว่าง'],
      credit_dayRules: [v => !!v && (v <= 1000000) || 'กรุณากรอกจำนวนวันในการติดเครดิต'],
      addCredit: {
        id: null,
        type_user: '1',
        delivery_type: '1',
        clinics_ck: 0,
        name: null,
        telephone: '',
        email: null,
        tax_number: '',
        credit_balance: '',
        address: null,
        sub_district: null,
        district: null,
        province: null,
        postcode: null,
        address_delivery: null,
        sub_district_delivery: null,
        district_delivery: null,
        province_delivery: null,
        postcode_delivery: null,
        chiang_mai_cod: null,
        credit_day: '',
      },
    }
  },
  methods: {
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    onlyNumberCredit: function (evt, number) {
      return onlyForNumberCredit(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    createAlert() {
      Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
          .then(() => {
            this.$router.push('/customer');
          });
    },
    duplicate_address() {
      if (this.addCredit.type_user === '2' && this.addCredit.delivery_type === '1'){
        this.addCredit.address_delivery = this.addCredit.address;
        this.addCredit.sub_district_delivery = this.addCredit.sub_district;
        this.addCredit.district_delivery = this.addCredit.district;
        this.addCredit.province_delivery = this.addCredit.province;
        this.addCredit.postcode_delivery = this.addCredit.postcode;
      }
    },
    unduplicate_address() {
      this.addCredit.address_delivery = null;
      this.addCredit.sub_district_delivery = null;
      this.addCredit.district_delivery = null;
      this.addCredit.province_delivery = null;
      this.addCredit.postcode_delivery = null;
    },
    clear_address() {
      this.addCredit.address_delivery = null;
      this.addCredit.sub_district_delivery = null;
      this.addCredit.district_delivery = null;
      this.addCredit.province_delivery = null;
      this.addCredit.postcode_delivery = null;
    },
    genIdCode() {
      HTTP.post('/customers/getcusid')
          .then((res) => {
            if (res.data.success === true){
              this.addCredit.id = res.data.object;
            }
          })
    },
    createCredit() {
      if (this.addCredit.type_user === '2' && this.addCredit.delivery_type === '1') {
        this.addCredit.address_delivery = this.addCredit.address;
        this.addCredit.sub_district_delivery = this.addCredit.sub_district;
        this.addCredit.district_delivery = this.addCredit.district;
        this.addCredit.province_delivery = this.addCredit.province;
        this.addCredit.postcode_delivery = this.addCredit.postcode;
      }
      if (this.$refs.add_form.validate()) {
        if (this.addCredit.credit_balance <= 1000000) {
          let data = {
            customer_type: 2,
            // delivery_type: this.addCredit.delivery_type, //เพิ่ม 1 field
            clinics: this.addCredit.clinics_ck, //เพิ่ม 1 field
            is_deliveryfreecnx: this.addCredit.chiang_mai_cod,
            customer_status: this.addCredit.type_user,
            name: this.addCredit.name,
            telephone: this.addCredit.telephone,
            email: this.addCredit.email,
            credit_balance: this.addCredit.credit_balance,
            credit_day: this.addCredit.credit_day,
            customer_personal_id: this.addCredit.tax_number,
            address: this.addCredit.address,
            sub_district: this.addCredit.sub_district,
            district: this.addCredit.district,
            province: this.addCredit.province,
            postcode: this.addCredit.postcode,
            address_delivery: this.addCredit.address_delivery,
            sub_district_delivery: this.addCredit.sub_district_delivery,
            district_delivery: this.addCredit.district_delivery,
            province_delivery: this.addCredit.province_delivery,
            postcode_delivery: this.addCredit.postcode_delivery,
            is_delivery_same_address: this.addCredit.delivery_type,
            status: 1,            
          }
          if(this.addCredit.type_user == 2){
            data = {
              customer_type: 2,
              // delivery_type: this.addCredit.delivery_type, //เพิ่ม 1 field
              clinics: this.addCredit.clinics_ck, //เพิ่ม 1 field
              is_deliveryfreecnx: this.addCredit.chiang_mai_cod,
              customer_status: this.addCredit.type_user,
              name: this.addCredit.name,
              telephone: this.addCredit.telephone,
              email: this.addCredit.email,
              credit_balance: this.addCredit.credit_balance,
              credit_day: this.addCredit.credit_day,
              customer_personal_id: this.addCredit.tax_number,
              address: this.addCredit.address,
              sub_district: this.addCredit.sub_district,
              district: this.addCredit.district,
              province: this.addCredit.province,
              postcode: this.addCredit.postcode,
              address_delivery: this.addCredit.delivery_type == 1 ? this.addCredit.address_delivery : this.addCredit.address,
              sub_district_delivery: this.addCredit.delivery_type == 1 ? this.addCredit.sub_district_delivery : this.addCredit.sub_district,
              district_delivery: this.addCredit.delivery_type == 1 ? this.addCredit.district_delivery : this.addCredit.district,
              province_delivery: this.addCredit.delivery_type == 1 ? this.addCredit.province_delivery : this.addCredit.province,
              postcode_delivery: this.addCredit.delivery_type == 1 ? this.addCredit.postcode_delivery : this.addCredit.postcode,
              is_delivery_same_address: this.addCredit.delivery_type,
              status: 1,            
            }
          }
          HTTP.post('/customers/create', data).then((res) => {
            if (res.data.success === true) {
              this.$refs.add_form.resetValidation()
              this.createAlert();
            } else {
              Swal.fire({
                title: 'ไม่สามารถดำเนินการได้ !',
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.addCredit.telephone = ''
              })
            }
          })
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'เนื่องจากยอดเครดิตเกิน 1,000,000 บาท',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.addCredit.credit_balance = ''
          })
        }
      }
      else {
        Swal.fire({
          title: 'ไม่สามารถดำเนินการได้ !',
          text: 'กรุณาตรวจสอบข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.$refs.add_form.validate()
        })
      }
    },
  },
  mounted() {
    this.genIdCode();
  }
}
</script>

<style scoped>
.custom_css >>> input {
  font-size: 18px;
  border-color: #9b9b9b;
  border-radius: 5px;
  padding: 16px;
  height: 56px !important;
}
.custom_css >>> input:hover {
  border-color: black;
}
.custom_css >>> input:focus {
  border-color: #8cc63e !important;
  border: solid 2px;
  padding: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.display_pc {
  display: grid;
}
.display_mobile {
  display: none;
}
@media only screen and (max-width: 500px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_mobile {
    width: 100%;
  }
  .display_pc {
    display: none;
  }
  .display_mobile {
    display: grid;
  }
}
</style>
